import { render, staticRenderFns } from "./ModalExcluir.vue?vue&type=template&id=76702ef2"
import script from "./ModalExcluir.vue?vue&type=script&lang=js"
export * from "./ModalExcluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports